export const DATA_PATTERN = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

export const HORA_PATTERN = [/\d/, /\d/, ':', /\d/, /\d/];